import HttpHelper from "../../helper";

export const aliMazharAskEndpoints = {
    getIsAsked: (mobileNumber) =>
        HttpHelper.fitnessAxios
            .post(`/question/isAsked`, { mobileNumber })
            .then((res) => res?.data),
};
